import { combineReducers } from "redux";
import { TransactionLogState } from "../types";
import device from "./device";
import transaction from "./transaction";
import alarmAnalysis from "./alarmAnalysis";
import notificationEvent from "./notificationEvent";

export default combineReducers<TransactionLogState>({
    device,
    transaction,
    alarmAnalysis,
    notificationEvent
});
